import { loadStripe } from '@stripe/stripe-js';

/** One Stripe.js instance for the whole app — several instances trip Stripe's own warning. */
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;
